import React, { useCallback } from 'react'
import { bool } from 'prop-types'
import { A, Button } from '@rebrandly/styleguide'

import config from '../config'
import { redirectToSignUp } from '../utils/auth'
import { getLinksFromCookie } from '../utils/common'


const FreeTrialButton = ({ children, isQr, ...rest }) => {
  const handleBuyNow = useCallback(() => {
    const { redirectToSignUp } = require('../utils/auth')

    const validLinks = getLinksFromCookie(isQr)

    const redirectUrl = redirectToSignUp && redirectToSignUp({
      isPricing: true,
      path: `/checkout/trial/${config.freeTrialPlanDealId14Days}`,
      search: `?planId=${config.limPanId}&activationId=${config.limDealId}`,
      isTrialSkipVerification: true,
      category: 'FREETRIAL', // This query param is what makes the .NET OAuth proj to change the Left Side of the HTML
      planName: 'Essentials LIM',
      links:  validLinks.map(link => ({ id: link.id }))
    });
    return window.open(redirectUrl, '_blank')
  },[isQr])

  return (
    <>
      {children && <A onClick={handleBuyNow} target='_blank' rel='noopener noreferrer' {...rest}>{children}</A>}
      {!children && <Button onClick={handleBuyNow} {...rest} />}
    </>
  )
}

FreeTrialButton.propTypes = {
  isQr: bool
}

export default FreeTrialButton
